import Filter from "./filter/PluginSetup.js";
import Sort from "./sort/PluginSetup.js";
import ClearAllAction from "./ClearAllAction.js";
export default {
  install(molten) {
    molten.addPlugin('Action', ClearAllAction);
    Filter.install(molten);
    Sort.install(molten);
  }
};